import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import Sticky from 'react-stickynode';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import matchMediaDesktop from '../../../../utils/client_util';

/*
 import { canUseDOM } from 'exenv';
 if(canUseDOM) {
 debugger;
 }
 */

class WP extends Component {
  // eslint-disable-line react/prefer-stateless-function

  componentDidMount() {
    this.isDesktop = matchMediaDesktop();
  }

  render() {
    const { wpPage, customPage } = this.props;

    if (wpPage.error && customPage.error) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (wpPage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(wpPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    const content = get(customPage, 'content.rendered');
    const singleColLayout = [
      'about',
      'most-innovative-companies',
      'world-changing-ideas'
    ];

    // This conditional is for non-standard custom WP Page layouts like franchise awards pages
    const slug = get(customPage, 'slug');
    const lookup = {
      about: {
        modifier: 'ibd',
        img:
          'https://assets.fastcompany.com/image/upload/w_700,h_400,c_crop,q_auto:best,f_auto,fl_lossy/v1500314681/fcweb/3056495-poster-ibd-logo-poster-thin_qmvllz.jpg',
        link: ''
      },
      'most-innovative-companies': {
        modifier: 'mic',
        img:
          'http://assets.fastcompany.com/image/upload/w_700,h_400,c_crop,q_auto:best,f_auto,fl_lossy/v1497392323/fcweb/mic-logo-poster.jpg',
        link: 'https://fastcompany.swoogo.com/mic',
        alt: '2018 Most Innovative Companies'
      },
      'world-changing-ideas': {
        modifier: 'wci',
        img:
          'https://assets.fastcompany.com/image/upload/w_750,q_auto:best,f_auto,fl_lossy/v1500305337/fcweb/wci_anobzi.jpg',
        link: null,
        alt: 'World Changing Ideas'
      }
    };

    const header = lookup[slug] || null;

    if (singleColLayout.indexOf(get(customPage, 'slug')) > -1) {
      return (
        <section className="awards-page">

          {header
            ? <header
                className={`awards-page__header awards-page__header--${header.modifier}`}
              >
                <a href={header.link} title={header.alt}>
                  <img src={header.img} alt={header.alt} />
                </a>
              </header>
            : ''}
          <section className="awards-page__content">
            <div className="awards-page__main">
              <article dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </section>

        </section>
      );
    }

    return (
      <section className="custom-page">
        <div className="post_wrapper">
          <section className="custom-content">
            <div className="post">
              <div className="post__main">
                <h1 className="post__title">
                  {get(customPage, 'title.rendered')}
                </h1>
                <article
                  className="post__article"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
              <div className="post__sidebar" id="custom-page-ad">
                {content && content.length
                  ? <Sticky
                      top={100}
                      bottomBoundary="#custom-page-ad"
                      enabled={this.isDesktop}
                    >
                      <Ad
                        {...combinedAdModel}
                        noLazyLoad={true}
                        pos="atf"
                        name="flexiblehalfpage"
                      />
                    </Sticky>
                  : ''}
              </div>
            </div>
          </section>
        </div>
        <section className="recirc-feed">
          {!isEmpty(customPage)
            ? <div>
                <Ad {...combinedAdModel} name="flexiblebillboard_1" />
                <Ad {...combinedAdModel} name="mobileparallax_1" />
              </div>
            : ''}
        </section>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    wpPage: state.wpPage || {
      ads: {
        baseConfig: {}
      }
    },
    customPage: get(state, 'customPage.data.page[0]') || { error: true }
  };
}

WP.propTypes = {
  wpPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  customPage: PropTypes.shape({
    error: PropTypes.bool
  }).isRequired
};

export default connect(mapStateToProps)(WP);



// WEBPACK FOOTER //
// ./src/views/containers/pages/wp_page/wp_page.js